import TouchableRippleM from "@common/components/button/TouchableRippleM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { hasRole } from "@data/utility/ability"
import { AbilityContext } from "@data/utility/Can"
import { useNavigation } from "@react-navigation/native"
import moment from "moment"
import React, { useContext } from "react"
import { View } from "react-native"
import {
    SubscriptionPrivilegeChip,
    SubscriptionProductChip,
} from "../SubscriptionPrivilegeChip"

export function SubscriptionStateCard({ user, style, disabled }) {
    const ability = useContext(AbilityContext)
    const navigation = useNavigation()
    const onPress = () => {
        navigation.push("my-privileges")
    }

    const productName = user?.subscription_state?.plan

    return hasRole(user, "student") ? (
        <>
            <TouchableRippleM
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 15,
                    flexWrap: "wrap",
                    ...style,
                }}
                onPress={onPress}
                disabled={disabled}
                underlayColor={theme.colors.lightMore}
            >
                <>
                    <View style={{ flexDirection: "row" }}>
                        <SubscriptionProductChip
                            product={productName}
                            style={{ marginRight: 10 }}
                        />

                        {ability.can("read", "holiday_course_views") && (
                            <SubscriptionPrivilegeChip
                                product={"holidaycourse"}
                                style={{ marginRight: 10 }}
                            />
                        )}
                    </View>
                    <View>
                        {moment(user?.trial_ends_at).isAfter(moment()) ? (
                            <TextM style={{ marginRight: 5 }} wrap>
                                Fin de l'essai gratuit : le{" "}
                                {moment(user?.trial_ends_at).format(
                                    "DD MMMM YYYY"
                                )}
                            </TextM>
                        ) : (
                            <TextM
                                fontWeight="Medium"
                                color={theme.colors.grey}
                                style={{ marginRight: 5 }}
                                wrap
                                fontSize={14}
                            >
                                Voir les détails
                            </TextM>
                        )}
                    </View>
                </>
            </TouchableRippleM>
        </>
    ) : null
}
